{
  "customOrderHistory": {
    "sortOptions": {
      "label": "Sortieren nach",
      "code": "Bestellung",
      "position": "Position",
      "state": "Status",
      "description": "Produktinfo",
      "orderDate": "Datum",
      "deliverKW": "Liefer KW",
      "valutaDate": "Valuta",
      "shippingCosts": "Fracht",
      "totalPrice": "Nettowert",
      "netPrice": "Nettowert",
      "orderState": "Status",
      "productCode": "Artikel",
      "orderedQuantity": "Menge Bestellt",
      "deliveredQuantity": "Menge Offen",
      "formattedDeliverKW": "Liefer KW"
    },
    "sortDirections": "Sortierreihenfolge",
    "sortDirection": {
      "asc": "Aufsteigend",
      "desc": "Absteigend"
    },
    "states": {
      "COMPLETED": "Bestellung erledigt",
      "RESERVED": "Reserviert",
      "SHIPPING": "In Zustellung",
      "WITH_OPEN_POSITIONS": "Bestellung hat offene Positionen"
    },
    "filter": {
      "OVERVIEW": "Übersicht",
      "OPEN": "Offen",
      "REMAINS": "Rückstand"
    },
    "search": {
      "orders": "Bestellungen",
      "orderDateFrom": "Datum ab",
      "orderDateTo": "bis",
      "uigOrderNumber": "RF Bestellnr.",
      "productCode": "Artikelnummer",
      "searchFor": "Suchen nach",
      "searchForText": "(Bspw.: Bestellung, Artikel, Begriff aus Produktinfo)"
    },
    "fileName": {
      "order": "Bestellpositionen",
      "overview": "Bestellungen-Übersicht",
      "remains": "BestellungenRückständigePositionen"
    },
    "dialog": {
      "orderDelete": {
        "title": "Bestellung löschen",
        "body": "Wollen Sie den Bestellung wirklich löschen?"
      },
      "orderPositionDelete": {
        "title": "Position löschen",
        "body": "Wollen Sie die Position wirklich löschen?"
      }
    },
    "detail": {
      "orderNumber": "Bestellnr.:",
      "date": "Datum:",
      "note": "Bemerkung:",
      "shippingCosts": "Frachtkosten:",
      "totalPrice": "Nettowert:"
    },
    "buttons": {
      "search": "Suchen",
      "reset": "Zurücksetzen",
      "export": "Drucken/Exportieren",
      "cancel": "Löschen",
      "update": "Ändern",
      "updateEntry": "Ändern",
      "updateAll": "Alle Ändern",
      "back": "Zurück zur Übersicht",
      "ok": "Ok",
      "cancelText": "Abbruch"
    },
    "orderNumber": "Bestellung",
    "date": "Datum",
    "status": "Status",
    "total": "Total",
    "returnToOverview": "Zurück zur Übersicht",
    "plannedDelivery": "Liefer KW",
    "valutaDate": "Valuta",
    "deliveryAddress": "Adresse",
    "customerReference": "Bemerkung",
    "shippingCosts": "Fracht",
    "totalPrice": "Nettowert",
    "sortByDate": "Datum",
    "sortByOrderNumber": "Bestellung",
    "sortByStatus": "Status",
    "sortByPlannedDelivery": "Liefer KW",
    "error": "Bestellungen konnten nicht abgerufen werden.",
    "errorOrder": "Bestellung konnte nicht abgerufen werden.",
    "errorCancelOrder": "Bestellung konnte nicht gelöscht werden.",
    "errorCancelOrderEntry": "Position konnte nicht gelöscht werden.",
    "errorUpdateOrderEntries": "Update war nicht erfolgreich.",
    "errorExportOrder": "Die Bestellung konnte nicht exportiert werden.",
    "successCancelOrder": "Bestellung wurde gelöscht.",
    "successCancelOrderEntry": "Position wurde gelöscht.",
    "successUpdateOrderEntries": "Update war erfolgreich.",
    "position": "Position",
    "productCode": "Artikel",
    "description": "Produktinfo",
    "orderedQuantity": "Menge",
    "deliveredQuantity": "Offen",
    "deliveredQuantityNow": "Offen bisher",
    "deliveredQuantityNew": "Offen neu",
    "netPrice": "Nettowert",
    "textReLs": "Text für Lieferschein/Rechnung:",
    "downloadInfo": "Download startet automatisch, sobald der Export vorbereitet ist.",
    "noOrders": "Keine Bestellungen gefunden.",
    "noOrder": "Bestellung nicht gefunden.",
    "startShopping": "Weiter Shoppen"
  },
  "customManufacturerCampaign": {
    "manufacturer": "Hersteller",
    "campaign": "Aktion (ID - NAME)",
    "productCode": "Art.-Nr.",
    "productInfo": "Produktinfo",
    "validFrom": "Von",
    "validTo" : "Bis",
    "validDate": "Zeitraum",
    "editableUntil":"Meldung",
    "emptyTable": "Keine Daten in der Tabelle vorhanden",
    "error":"Aktionsmeldungen konnten nicht abgerufen werden.",
    "value": "Wert (€)",
    "combiValue1": "K1:",
    "combiValue2": "K2:",
    "combiCampaign": "Kombi",
    "search" : {
      "productCode":"Artikel-Nr",
      "manufacturerNumber":"Hersteller-Nr",
      "ean":"EAN",
      "campaignId":"Aktion",
      "manufacturerId":"Hersteller",
      "showOldData": "Ältere zeigen",
      "all": "Alle"
    },
    "sortDirections": "Sortierreihenfolge",
    "sortDirection": {
      "asc": "Aufsteigend",
      "desc": "Absteigend"
    },
    "buttons": {
      "search": "Suchen",
      "reset": "Zurücksetzen",
      "import" :"Import",
      "instruction":"Anleitung zur Aktionsmeldung",
      "delete": "Entfernen",
      "add": "Hinzufügen",
      "export": "Report erstellen",
      "downloadCalendar": "Kalendereintrag erstellen",
      "downloadCsv": "Download Übersicht"
    },
    "sortOptions": {
      "label": "Sortieren nach",
      "manufacturer": "Hersteller",
      "id": "Aktion (ID - NAME)",
      "productCode": "Art.-Nr.",
      "productName": "Produktinfo",
      "validFrom": "Zeitraum Von",
      "validTo" : "Zeitraum Bis",
      "editableUntil":"Meldung Bis"
    },
    "import" : {
      "title":"Import über CSV-Datei:",
      "text":"Mehrere Datensätze über eine erstellte CSV-Datei auf einmal übernehmen.",
      "noFileSelected" :"Keine ausgewählt",
      "success" : "Der Import wurde erfolgreich abgeschlossen.",
      "unauthorizedCampaignCode":"Der Aktionscode aus folgenden Zeilen wurde nicht übernommen, da dieser für die Aktion nicht erforderlich ist:",
      "errors" : {
        "invalidFileType":"Zu importierende Datei ist keine CSV!",
        "hasDuplicates":"Eine oder mehrere dieser Seriennummer/n wurde/n bereits für die Aktion eingetragen",
        "invalidEntries":"Eine oder mehrere der importierten Zeilen enthielten fehlerhafte oder nicht zulässige Daten und wurden daher nicht übernommen"
      }
    },
    "instructions": {
      "title": "Anleitung zur Aktionsmeldung",
      "downloadLink": "hier abrufbarem Muster",
      "informationParagraph": "<p>Sie können wahlweise eine Suche nach Artikel-Nr., Hersteller-Nr., EAN und/oder Aktion durchführen und die Ergebnisliste entsprechend filtern. Auch die Sortierung können Sie vorbelegen. Achtung, falls Sie ältere abgelaufene Aktionen sehen möchten, bitte das Kontrollkästchen „Ältere zeigen“ aktivieren.</p><p>Klicken Sie auf eine der Aktionszeilen. Bitte beachten Sie den Zeitraum, in dem Sie die Artikel verkauft haben müssen (Zeitraum) und den Zeitpunkt, bis zu dem Sie die Meldung eingeben müssen (Meldung).</p><p>Bitte tragen Sie die Serien-Nummern sowie das Verkaufsdatum ein, im Falle von Set-Artikeln - wie z. B. Digital Spiegelreflex-Sets - bitte nur die Gehäuse-Seriennummer.<br>Hinzufügen (\"+\") klicken und Speichern - die eingetragenen Abverkaufsdaten werden gesichert.</p><p>Folgenden Status haben ihre Meldungen.</p>",
      "status1": "= „offen“ Die Daten können bis zum Meldetermin geändert oder wieder entfernt werden.",
      "status2": "= „In Bearbeitung“ Die Daten werden verarbeitet und eine Änderung ist nicht mehr möglich.",
      "status3": "= „Abgelehnt“ Die Auszahlung wurde abgelehnt.",
      "status4": "= „Ausgezahlt“ Eine Gutschrift wurde erfasst und die Zahlung angewiesen.",
      "importCsvParagraphTitle": "Import über CSV-Datei:",
      "importCsvParagraph": "Sie können über den Import einer CSV-Datei gemäß ",
      "importCsvParagraphContinued":  " auch mehrere Datensätze auf einmal ins System hochladen.",
      "importCsvParagraphContinued2":  "Über den Button „Report erstellen“ können Sie die erfassten Meldungen einer oder mehrerer Aktionen als CSV-Datei exportieren.",
      "importCsvTemplateHeader": "'Aktions-ID;Artikelnummer;Seriennnumer;Verkaufsdatum;2. Serien-Nr.;2. Bezeichnung;Kombi-Produkt K1;Serien-Nr. K1;Kombi-Produkt K2;Serien-Nr. K2'",
      "importCsvParagraphAfterTemplate": "(Trennzeichen: Semikolon) anzugeben und es darf keine Kopfzeile mit den Spaltenbezeichnungen eingefügt werden.",
      "close": "Schlie\u00DFen"
    },
    "details": {
      "product": "Artikel",
      "manufacturerArticleNo": "Herst.-Art.Nr.",
      "title": "Aktionsmeldungen erfassen",
      "error": "Aktionsmeldungen erfassen konnten nicht abgerufen werden.",
      "serialNumbers": "Serien-NR.",
      "campaignCode":"Aktionscode",
      "salesDate": "verkaufsdatum",
      "updateParagraph": "Bitte tragen Sie die Serien-Nummern sowie das Verkaufsdatum ein, im Falle von Set-Artikeln - wie z. B. Digital Spiegelreflex-Sets - bitte nur die Gehäuse-Seriennummer. Zum Hinzufügen bitte auf \"+\", zum Entfernen auf das Papierkorb-Symbol klicken.<br> Speichern - sichert die sichtbaren und löscht ggf. entfernte Daten.",
      "required": "(erforderlich)",
      "tradeInSerialNo":"2. SERIEN-NR.",
      "tradeInName":"BEZEICHNUNG",
      "combiArticles": "Kombi-Artikel",
      "combiArticleOptional": "2. Kombi-Artikel optional:",
      "combiProduct1": "K1: ",
      "combiProduct2": "K2: ",
      "combiSerialNumbers": "Kombi Serien-NR.",
      "placeholder_1": "Artikel 1 wählen",
      "placeholder_2": "Artikel 2 wählen"
    },
    "messages": {
      "deleteSuccess": "Die Aktionsmeldungen wurde erfolgreich gelöscht.",
      "deleteFailure": "Die Aktionsmeldungen konnte nicht gelöscht werden.",
      "updateSuccess": "Die Aktionsmeldungen wurde erfolgeich aktualisiert.",
      "updateFailure": "Eine oder mehrere dieser Seriennummer/n wurde/n bereits für die Aktion eingetragen."
    },
    "export": {
      "productInfo": "Sie können durch Auswahl von Produkten den Export auf diese Produkte beschränken:",
      "title": "Report als CSV-Export:",
      "heading": "Exportieren",
      "noResults": "Keine Ergebnisse gefunden",
      "campaignCode":"Aktionscode",
      "fromDate": "Erfasst zwischen",
      "toDate": "Erfasst bis",
      "selectCampaignOptions":"Aktion(en) auswählen ..."
    },
    "states": {
      "processing": "In Bearbeitung",
      "paid": "Ausgezahlt",
      "rejected": "Abgelehnt"
    }
  },
  "customStockProtection": {
    "instructions": {
      "title": "Anleitung zum Lagerwertausgleich",
      "downloadLink": "hier abrufbarem Muster",
      "informationParagraph": " <p>Klicken Sie auf eine der \u0022Vorgangs\u0022-Nummern (wahlweise ist eine Direkteingabe der Artikel-Nr. oder des Ringfoto-Vorgangs m\u00F6glich).</p><p>Bitte beachten Sie den Zeitraum, in dem Sie Ihre noch am Lager befindliche Ware bezogen haben m\u00FCssen (Lieferzeitraum) und den Zeitraum, in dem Sie die Eingabe in RIO machen m\u00FCssen (Meldezeitraum).</p>",
      "informationParagraphContinued": "<p><strong>Bitte tragen Sie die Serien-Nummern ein (maximal 30 Zeichen m\u00F6glich). <br/>Im Falle von Set-Artikeln - wie z. B. Systemkameras - bitte nur die Geh\u00E4use-Seriennummer eintragen!<br/>Eine Trennung durch Komma oder andere Sonderzeichen kann zu \u00DCbermittlungsfehlern f\u00FChren!</strong></p><p><strong>Mit „+“ Hinzufügen</strong> klicken und <strong>Speichern</strong> - übermittelt die eingetragenen Seriennummern.</p><p>Nach dem Meldezeitraum werden alle Lagerwertausgleichsvorgänge nochmals geprüft und anschließend gutgeschrieben.</p>",
      "importCsvParagraph": "Import \u00FCber CSV-Datei: Sie k\u00F6nnen \u00FCber den Import einer CSV-Datei gem\u00E4\u00DF",
      "importCsvParagraphContinued": " auch mehrere Datens\u00E4tze auf einmal ins System hochladen.",
      "importCsvParagraphContinued2":  "Über den Button „Report erstellen“ können Sie die erfassten Meldungen einer oder mehrerer Aktionen als CSV-Datei exportieren.",
      "statesHeader": "Folgende Status sind m\u00F6glich:",
      "close": "Schlie\u00DFen"
    },
    "states": {
      "new": "Neuer Lagerwertausgleich",
      "finishedWithCredit": "Vorgang erledigt, Gutschrift erstellt",
      "finishedWithoutCredit": "Vorgang erledigt, keine Gutschrift erstellt",
      "01": "Neuer Lagerwertausgleich",
      "02": "In Bearbeitung Rückmeldung steht noch aus",
      "03": "Vorgang erledigt, Gutschrift erstellt",
      "04": "Lieferanten-Prüfung aktiviert, jedoch teilweise abgelehnt",
      "05": "Vorgang erledigt, Gutschrift teilweise erstellt",
      "06": "Vorgang erledigt, keine Gutschrift erstellt",
      "07": "Keine Daten vorhanden",
      "valid": "Ok",
      "invalid": "Seriennummer nicht bekannt",
      "notfound": "Außerhalb des Bezugszeitraums"
    },
    "search": {
      "articleNumber": "Artikel-Nr",
      "scenario": "Szenarien"
    },
    "scenarioFilter": {
      "ALL": "Alle Vorgänge anzeigen",
      "CURRENT_UNFINISHED": "Alle aktuellen und noch nicht abgeschlossenen Vorgänge",
      "COMPLETED_UNRECORDED": "Alle abgeschlossenen oder nicht erfassten Vorgänge"
    },
    "buttons": {
      "search": "Suchen",
      "reset": "Zurücksetzen",
      "delete": "Entfernen",
      "add": "Hinzufügen",
      "save": "Speichern",
      "check": "Prüfen",
      "import": "Import"
    },
    "sortOptions": {
      "label": "Sortieren nach",
      "processNumber": "Vorgang",
      "state": "Status",
      "productCode": "Artikel",
      "productTitle": "Produktinfo",
      "deliveryPeriodFrom": "Lieferzeitraum von",
      "deliveryPeriodTo": "Lieferzeitraum bis",
      "reportingPeriodFrom": "Meldung von",
      "reportingPeriodTo": "Meldung bis",
      "value": "Wert",
      "currency": "W\u00e4hrung"
    },
    "sortDirections": "Sortierreihenfolge",
    "sortDirection": {
      "asc": "Aufsteigend",
      "desc": "Absteigend"
    },
    "details": {
      "title": "Lagerwertausgleich - Details ansehen",
      "error": "Lagerwertausgleich Details konnten nicht abgerufen werden.",
      "serialNumbers": "Serien-NR.",
      "deliveryStatus": "Lieferantenstatus",
      "updateParagraph": "Bitte tragen Sie die Serien-Nummern ein, im Falle von Set-Artikeln - wie z. B. Digital Spiegelreflex-Sets - bitte nur die Gehäuse-Seriennummer eintragen<br/>Zum Hinzufügen bitte auf \"+\", zum Entfernen auf das Papierkorb-Symbol klicken<br/>Prüfen - Optional kann die Seriennummer vor dem Speichern überprüft werden<br/>Speichern - übermittelt die eingetragenen Seriennummern"
    },
    "deliveryStatus": {
      "001": "In Lieferantenprüfung",
      "002": "Freigabe zur Gutschrift",
      "003": "Gutschrift erstellt",
      "004": "Freigabe zur Kulanzgutschrift",
      "005": "In Prüfung",
      "006": "Abgelehnt",
      "007": "Abgelehnt - Canon Direktkunde"
    },
    "uigProcess": "Vorgang",
    "status": "Status",
    "articleNumber": "Art.",
    "productInfo": "Produktinfo",
    "stockProtectionValue": "Wert",
    "stockProtectionCurrency": "W\u00e4hrung",
    "error": "Lagerwertausgleich konnten nicht abgerufen werden.",
    "fromDate": "von",
    "toDate": "bis",
    "emptyTable": "Keine Daten in der Tabelle vorhanden",
    "noFileSelected": "Keine ausgewählt",
    "importTitle": "Import über CSV-Datei:",
    "importText": "Hier können Sie mehrere Datensätze über eine erstellte CSV-Datei auf einmal übernehmen.",
    "deliveryPeriodFrom": "Lieferzeitraum von",
    "deliveryPeriodTo": "Lieferzeitraum bis",
    "reportingPeriodFrom": "Meldung von",
    "reportingPeriodTo": "Meldung bis",
    "deliveryPeriod": "Lieferzeitraum",
    "reportingPeriod": "Meldung",
    "manufacturerPrice": "Herst. EK-Ausgleich"
  },
  "customUserPayments": {
    "search": {
      "invoiceDateFrom": "Datum ab",
      "invoiceDateTo": "bis",
      "amountFrom": "Betrag von",
      "amountTo": "bis",
      "invoiceNumber": "Re. / Bu. Nr.",
      "referenceNumber": "Referenz Nr.",
      "articleNumber": "Artikel Nr.",
      "notificationNumber": "Avis Nr.",
      "orderType": "Auftragsart",
      "bookingType": "Buchungsart",
      "openPositions": "nur offene Posten:"
    },
    "sortOptions": {
      "label": "Sortieren nach",
      "invoiceNumber": "Beleg",
      "referenceNumber": "Referenz",
      "invoiceDate": "Re. / Bu. Datum",
      "dueDate": "fällig",
      "amount": "Betrag",
      "debitOrCredit": "Soll / Haben",
      "deliveryStatus": "Lager / Str.",
      "notificationNumber": "Avis Nr.",
      "notificationDate": "A. Datum",
      "discount": "Skonto",
      "collectedAmount": "Einzug €",
      "accumulatedValue": "Akkum"
    },
    "sortDirections": "Sortierreihenfolge",
    "sortDirection": {
      "asc": "Aufsteigend",
      "desc": "Absteigend"
    },
    "bookingType": {
      "ALL": "Alle",
      "DEBIT": "Soll",
      "CREDIT": "Haben"
    },
    "orderType": {
      "ALL": "Alle",
      "CAMP": "Lager",
      "ROUTE": "Strecke"
    },
    "buttons": {
      "search": "Suchen",
      "reset": "Zurücksetzen",
      "export": "Drucken/Exportieren",
      "back": "Zurück zur Übersicht",
      "exportOnly": "Exportieren"
    },
    "files": {
      "overview": "Kontoübersicht",
      "details": "Rechnungsdetails"
    },
    "details": {
      "deliveryNote": "Lieferschein",
      "ourOrder": "RF Bestellnr.",
      "orderDate": "Bestelldatum",
      "valueDate": "Valuta datum",
      "address": "Versandadresse",
      "totalAmount": "Rechnungsbeträge Endbetrag",
      "netAmount": "Netto",
      "tax": "MwSt.",
      "boxing": "Verpackung",
      "shipment": "Versand",
      "discount1": "Rabatt 1:",
      "discount2": "Rabatt 2:",
      "invoiceTitle": "Rechnungs-Nr.:",
      "invoiceDate": "Rechnungsdatum:"
    },
    "avis": {
      "number": "Avis-Nr.:",
      "date": "Avis-Datum:",
      "balance": "Rechnungsbetrag:",
      "cashDiscount": "Skonto-Betrag:",
      "plannedAmount": "Einzugs-Betrag:",
      "warehouse": "Art",
      "accDocumentNumber": "Rechnungs Nr.",
      "billingDate": "Rechnungs datum",
      "amount": "Rechnungs betrag",
      "cashDiscountTitle": "Skonto betrag",
      "plannedAmountTitle": "Einzugs-/Gut schriftbetrag"
    },
    "invoice": "Beleg",
    "reference": "Referenz",
    "invoiceDate": "Re. / Bu. Datum",
    "dueDate": "fällig",
    "amount": "Betrag",
    "debitOrCredit": "Soll / Haben",
    "warehouseOrThirdparty": "Lager / Str.",
    "notificationNo": "Avis Nr.",
    "notificationDate": "A. Datum",
    "discountValue": "Skonto",
    "collectionAmount": "Einzug €",
    "accumulatedValue": "Akkum",
    "pdf": "PDF",
    "balanceWarehouse": "Saldo (nur Lager):",
    "balanceThirdParty": "Saldo (nur Strecke):",
    "balance": "Saldo:",
    "downloadInfo": "Download startet automatisch, sobald der Export vorbereitet ist.",
    "errorExportInvoiceOverview": "Die Rechnungsverwaltung konnte nicht exportiert werden.",
    "emptyTable": "Keine Daten in der Tabelle vorhanden",
    "open": " = offen",
    "closed": " = erledigt",
    "error": "Rechnungsübersicht konnten nicht abgerufen werden.",
    "pdfError": "PDF konnte nicht abgerufen werden.",
    "errorExportInvoiceDetails": "Die Rechnungsdetails konnte nicht exportiert werden."
  },
  "deliveryNotes": {
    "sortOptions": {
      "label": "Sortieren nach",
      "orderNumber": "Bestell-Nr.",
      "position": "Bestellposition-Nr.",
      "productCode": "Art.-Nr.",
      "deliveredQuantity": "Menge",
      "unit": "Einheit",
      "description": "Artikelbeschreibung",
      "imei": "IMEI/Geräte-Nr.",
      "deliveryNumber": "Lieferschein",
      "deliveryMethod": "Versandart",
      "releaseDate": "Freigabe",
      "weightKG": "Gewicht in kg",
      "units": "Colli",
      "trackingUrl": "Verfolgung"
    },
    "sortDirections": "Sortierreihenfolge",
    "sortDirection": {
      "asc": "Aufsteigend",
      "desc": "Absteigend"
    },
    "states": {},
    "filter": {},
    "search": {
      "deliverynotes": "Lieferscheine",
      "deliveryDateFrom": "Datum ab",
      "deliveryDateTo": "bis",
      "deliveryId": "Lieferscheinnummer",
      "productCode": "Artikelnummer"
    },
    "fileName": {
      "overview": "Lieferungen-Übersicht",
      "delivery": "Lieferpositionen",
      "pdf": "Lieferschein"
    },
    "dialog": {},
    "detail": {
      "deliveryNumber": "Lieferschein-Nr.:",
      "deliveryMethod": "Versandart:",
      "deliveryText": "Text:",
      "formattedReleaseDate": "Freigabe:",
      "releaseDate": "Freigabe:",
      "trackingCode": "Verfolgung:",
      "trackingUrl": "Verfolgung:",
      "weightKG": "Gewicht in kg:",
      "units": "Colli:",
      "pdfUrl": "PDF:",

      "orderNumber": "Bestell-Nr.",
      "position": "Bestellposition-Nr.",
      "productCode": "Art.-Nr.",
      "deliveredQuantity": "Menge",
      "unit": "Einheit",
      "description": "Artikelbeschreibung",
      "imei": "IMEI/Geräte-Nr."
    },
    "buttons": {
      "search": "Suchen",
      "reset": "Zurücksetzen",
      "export": "Drucken/Exportieren",
      "back": "Zurück zur Übersicht",
      "ok": "Ok",
      "cancelText": "Abbruch"
    },
    "returnToOverview": "Zurück zur Übersicht",
    "deliveryNumber": "Lieferschein",
    "deliveryMethod": "Versandart",
    "formattedReleaseDate": "Freigabe",
    "trackingCode": "Verfolgung",
    "weightKG": "Gewicht in kg",
    "units": "Colli",
    "pdfUrl": "PDF",
    "sortByDate": "Datum",
    "sortByOrderNumber": "Bestellung",
    "sortByStatus": "Status",
    "sortByPlannedDelivery": "Liefer KW",
    "error": "Lieferscheine konnten nicht abgerufen werden.",
    "errorDeliveryNote": "Lieferschein konnte nicht abgerufen werden.",
    "errorExportOrder": "Die Bestellung konnte nicht exportiert werden.",
    "errorExportPdf": "Lieferschein (pdf) konnte nicht erstellt werden.",
    "position": "Position",
    "productCode": "Artikel",
    "description": "Produktinfo",
    "orderedQuantity": "Menge",
    "deliveredQuantity": "Offen",
    "deliveredQuantityNow": "Offen bisher",
    "deliveredQuantityNew": "Offen neu",
    "netPrice": "Nettowert",
    "textReLs": "Text für Lieferschein/Rechnung:",
    "downloadInfo": "Download startet automatisch, sobald der Export vorbereitet ist.",
    "noDeliveryNotes": "Keine Lieferscheine gefunden.",
    "noDeliveryNoteItems": "Keine Lieferscheinpositionen gefunden.",
    "startShopping": "Weiter Shoppen",
    "trackingUrl": "Verfolgung",
    "trackingLink": "Tracking"
  },
  "statistic": {
    "errorExportPdf": "Statistik (pdf) konnte nicht erstellt werden."
  },


  "customVendorReporting": {
    "emptyTable": "Keine Daten in der Tabelle vorhanden",
    "error":"Vendor Reporting konnten nicht abgerufen werden",
    "downloadInfo": "Download startet automatisch, sobald der Export vorbereitet ist.",
    "errorExportDataEvaluation": "Die Bestellung konnte nicht exportiert werden.",
    "search" : {
      "productCode":"Art.Nr",
      "manufacturerNumber":"Hersteller-Nr.",
      "ean":"EAN",
      "manufacturer":"Hersteller",
      "reportTransferType": "Typ",
      "reportTransferStatus": "Status",
      "reportTransferPeriod": "Meldezeitraum",
      "all": "Alle",
      "transferPeriodLabel":"Zeitraum",
      "transferDateFrom": "Von",
      "transferDateTo": "Bis",
      "showTransferredOnly": "Übertragene zeigen",
      "b2bUnit":"Kd.Nr",
      "reportCategory": "Report-Kategorie",
      "reportChannel": "Kanal"
    },
    "storeID":  "Filial-ID",
    "sortDirections": "Sortierreihenfolge",
    "sortDirection": {
      "asc": "Aufsteigend",
      "desc": "Absteigend"
    },
    "buttons": {
      "search": "Suchen",
      "reset": "Zurücksetzen",
      "import" :"Import",
      "instruction":"Anleitung zum Vendor Reporting",
      "save": "Speichern",
      "toggleEdit": "Übertragene Daten ändern",
      "export":"Export der Daten",
      "add": "Daten in der Reportzeile werden ohne ein Hinzufügen über die + Taste nicht gespeichert!"
    },
    "sortOptions": {
      "label": "Sortieren nach",
      "reportTransferPeriod":"Meldezeitraum",
      "transferDate":"Meldetag",
      "timeStamp":"Übertragungszeit",
      "fileName":"Dateiname",
      "b2bUnit":"Kd.Nr"
    },
    "import" : {
      "title":"Import über CSV-Datei:",
      "text":"Mehrere Datensätze über eine erstellte CSV-Datei auf einmal übernehmen.",
      "noFileSelected" :"Keine ausgewählt",
      "messages" :{
        "success" : "Der Import wurde erfolgreich abgeschlossen.",
        "successfulButUnauthorized":"Der Aktionscode aus folgenden Zeilen wurde nicht übernommen, da dieser für die Aktion nicht erforderlich ist",
        "invalidFileType":"Zu importierende Datei ist keine CSV!",
        "incorrectData":"Art.Nr. {{productCode}} - die Zeile enthält Fehler, Bitte prüfen. Es wurden keine Daten importiert.",
        "invalidProduct": "Art.Nr. {{productCode}} nicht gefunden, Bitte prüfen. Es wurden keine Daten importiert.",
        "duplicateData": "Die Datei enthält Duplikate. Bitte prüfen!",
        "invalidFileName": "Dateiname ist falsch.",
        "transferDataNotFound": "Die Datei konnte nicht richtig zugeordnet werden. Bitte prüfen.",
        "branchNotFound":"Filial-ID {{productCode}} nicht gefunden, bitte überprüfen. Es wurden keine Daten importiert..",
        "branchNotVendorReportingEnabled":"Die Filial-ID {{productCode}} ist nicht Vendor Reporting relevant, bitte überprüfen Sie dies. Es wurden keine Daten importiert.",
        "invalidInventoryDate":"Art.Nr. {{productCode}} - Ungültiges Bestandsdatum, sollte {{inventoryDate}} sein. Bitte prüfen."
      }
    },
    "manufacturer" : "Hersteller",
    "reportTransferType" : "Typ",
    "reportTransferPeriod" : "Meldezeitraum",
    "transferDate" : "Meldetag",
    "timestamp" : "Übertragen",
    "reportTransferStatus" : "Status",
    "dataCount" : "Datensätze",
    "reportTransferStatuses" : {
      "Open" : "Offen",
      "Success" : "Erfolg",
      "NoData" : "Keine Daten",
      "DataModified" : "Daten geändert",
      "Error" : "Fehler"
    },
    "reportTransferTypes" : {
      "Sales" : "Sales",
      "Inventory": "Inventory"
    },
    "reportChannelTypes" : {
      "General" : "General",
      "Online" : "Online",
      "Store" : "Store"
    },
    "fileName" : "Dateiname",
    "details": {
      "title": "Vendor Reporting erfassen",
      "productCode":"Art.Nr",
      "manufacturerPartNumber":"Hersteller-Nr.",
      "productName":"EAN/GTIN",
      "gtin":"EAN",
      "bundle": "Bundle",
      "invoiceDate": "Verkaufsdatum",
      "inventoryDate": "Bestandsdatum",
      "quantity": "Menge",
      "transactionType": "Typ",
      "onlineSale":"Online",
      "marketplaceSale":"Marktplatz",
      "productSupplier":"Lieferant",
      "YES":"Ja",
      "NO": "Nein",
      "required":"(erforderlich)",
      "error": "Vendor Reporting erfassen konnten nicht abgerufen werden.",
      "dataEvaluationTitle": "Vendor Reporting Detaildaten",
      "storeId": "Filial-ID",
      "productCodeType": "Art.Nr.-Typ",
      "productInfo": "Produktdaten",
      "ringfotoProductCode": "Ringfoto-Nr."
    },
    "messages" :{
      "error":"",
      "deleteSuccess":"Daten erfolgreich gelöscht.",
      "deleteFailure":"",
      "invalidProduct":"Art.Nr. {{productCode}} nicht gefunden. Bitte prüfen.",
      "saveSuccess":"Daten wurden erfolgreich gespeichert.",
      "duplicateData": "Art.Nr. {{productCode}} - Eintrag existiert bereits. Bitte prüfen!",
      "incorrectData":"Art.Nr. {{productCode}} konnte nicht hinzugefügt werden. Bitte prüfen!",
      "invalidInventoryDate":"Art.Nr. {{productCode}} - Ungültiges Bestandsdatum, sollte {{inventoryDate}} sein. Bitte prüfen."
    },
    "instructions": {
      "title": "Anleitung zum Vendor Reporting",
      "informationParagraph": "<p>Klicken Sie auf eine der Reportzeile (wahlweise ist auch eine Filterung der Suche nach Hersteller-Nr., EAN, Hersteller, Typ, Kanal, Art.Nr. oder Status m\u00F6glich). </p> <p> Bitte beachten Sie den Zeitraum, f\u00FCr den Sie die Produkte melden m\u00FCssen (Meldezeitraum) und den Zeitpunkt, bis zu dem Sie die Meldungen eingetragen haben m\u00FCssen (Meldetag). </p> <p> <span>Verkaufsdaten (Sales)</span>:<br> Bitte tragen Sie die Filial-ID, den Art.Nr.-Typ, die Art.Nr. sowie Bundle, Verkaufsdatum, Menge (darf nicht kleiner 1 sein), Typ, Lieferant, Online und Marktplatz ein. <br> <span>Bestandsdaten (Inventory)</span>:<br> Bitte tragen Sie die Filial-ID, den Art.Nr.-Typ, die Art.Nr. sowie Bestandsdatum, Menge und Lieferant ein (wobei das Bestandsdatum automatisch auf den letzten Tag des Meldezeitraums gesetzt wird). <br> <p>Als Art.Nr.-Typ stehen folgende Optionen zur Auswahl: </p> <ul><li>H = Hersteller-Nr.</li><li>R = Ringfoto-Nr.</li><li>E = EAN</li></ul> <p>Bitte achten Sie darauf, dass die Eingabe im Feld \u0022Art.Nr\u0022 dann auch entsprechend zur Auswahl passen muss, da es sonst zu einer Fehlermeldung kommt (selbst wenn es sich um eine gültige Nummer eines anderen Typs handelt). <p> <p> Nach Eingabe der Daten Hinzufügen (\u0022+\u0022-Icon) klicken und Speichern - die eingetragenen Meldungen werden nun gesichert. <br> Beim erneuten Öffnen des Reports werden bei Produktdaten die Hersteller-Nr., Ringfoto-Nr., EAN (ändert sich je nach ausgewähltem Art.Nr.-Typ) und die Bezeichnung automatisch angezeigt. <br> Sowohl zuvor erfasste als auch bereits gemeldete Daten können geändert oder auch wieder entfernt (Papierkorb-Symbol) werden. </p>",
      "importCsvParagraphTitle": "Import über eine CSV-Datei:",
      "importCsvParagraph": "Sie können über den Import einer CSV-Datei gemäß den nachfolgend abrufbaren Mustern (Sales, Inventory) auch mehrere Datensätze auf einmal ins System hochladen.",
      "importCsvParagraphContinued": "<p> Für eine erfolgreiche Verarbeitung der Datei beachten Sie bitte folgende Punkte: </p><ul> <li> Der Dateiname muss den Muster-Namen entsprechen: entweder <a href='assets/files/CanonInventory_xy.csv'>CanonInventory_xy </a> oder <a href='assets/files/CanonSales_xy.csv'> CanonSales_xy </a>. </li> <li> In der Datei sind die Datensätze jeweils einzeln je Zeile in der folgenden Form anzugeben (Trennzeichen: Semikolon \u0022;\u0022): <ul> <li> Sales: <br> Hersteller;Kd.Nr.;Land;Kanal;Typ;Meldezeitraum;Filial-ID;Art.Nr.-Typ;Art.Nr;Bundle;Verkaufsdatum;Menge;Transaktionstyp;Lieferant;Online;Marketplace </li> <li> Inventory: <br> Hersteller;Kd.Nr.;Land;Kanal;Typ;Meldezeitraum;Filial-ID;Art.Nr.-Typ;Art.Nr;Bestandsdatum;Menge;Lieferant </li> <li> Dabei sind in den nachfolgenden Feldern nur die angegebenen Werte zulässig: <ul> <li> Kanal: General/Store/Online</li> <li> Typ: Inventory/Sales</li> <li> Art.Nr.-Typ: H/R/E</li> <li> Bundle: YES/NO</li> <li> Transaktionstyp: S/R</li> <li> Lieferant: Vendor/Other</li> <li> Online: YES/NO</li> <li> Marketplace: YES/NO</li> </ul> </li> </ul> </li> <li> Sobald es zu einem Fehler kommt, wird die komplette Datei nicht verarbeitet. Eine entsprechende Fehlermeldung wird angezeigt. Bitte die Daten überprüfen und nochmal hochladen. </li></ul>",
      "importCsvParagraphAfterTemplate": "<p>Jede Nacht werden die erfassten Daten der Reportzeilen übertragen, deren Meldetag abgelaufen ist. Der Status ändert sich nach einer erfolgreichen Übertragung auf \u0022Erfolg\u0022 oder \u0022Fehler\u0022, falls bei der Übertragung etwas nicht geklappt hat.</p> <p> Die bereits übertragenen Meldungen können über das \u0022Anhaken\u0022 der Checkbox \u0022Übertragene zeigen\u0022 wieder in der Übersicht angezeigt werden. Das Klicken auf eine solche Reportzeile öffnet ein Popup der Detaildaten im Anzeigemodus. Durch das Klicken auf \u0022Übertragene Daten ändern\u0022 kann man die bereits gemeldeten Daten nachträglich auch nochmal ändern/ergänzen, wonach diese dann in der folgenden Nacht erneut übertragen werden. </p>",
      "close": "Schlie\u00DFen"
    },
    "b2bUnit":"Kd.Nr",
    "reportCategory": "Report-Kategorie",
    "partnerID":"PartnerID",
    "reportCountry":"Land",
    "reportChannel":"Kanal",
    "dataEvaluation":{
      "noOfRecords":"Anzahl Datensätze:",
      "noOfArticles":"Anzahl Artikel:",
      "noOfDealers":"Anzahl Händler:",
      "noOfQuantity":"Menge gesamt:"
    },
    "productCode":"Art.Nr",
    "manufacturerNumber":"Hersteller-Nr.",
    "ean":"EAN",
    "onlineSale":"Online",
    "salesType":"SALES-TYPE",
    "quantity":"Menge",
    "date":"Datum",

    "rioSortOptions": {
      "label": "Sortieren nach",
      "productCode":"Art.Nr",
      "b2bUnit":"Kd.Nr",
      "manufacturerPartNumber":"Hersteller-Nr.",
      "gtin":"EAN",
      "inventoryDate":"Bestandsdatum",
      "date":"Datum"
  },
    "reportCategory" : {
      "Daily" : "A (Täglich)",
      "Weekly": "B (Wöchentlich)",
      "Monthly":"C (Monatlich)"
    }
  }
}
